import * as signals from '../states/signals'
import { Signal, signal$ } from 'rwwa-rx-state-machine'
import { selectQuaddie } from '../integration'

let sideEffects: Rx.IDisposable

export function registerQuaddieTipsSideEffects() {
  sideEffects = signal$.takeUntil(signals.Teardown.signal$).subscribe((signal: Signal) => {
    if (signal.tag === signals.SelectQuaddie) {
      selectQuaddie(signal.data.raceNumbers, signal.data.acceptorNumbers)
    }
  })
}

export function deregisterQuaddieTipsSideEffects() {
  sideEffects.dispose()
}
